module.exports = __webpack_public_path__ + "img/fzlc2021.5782b7e0.png";